"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AppUserProfileInCmsPatch = exports.AppUserProfileInCmsPost = exports.AppUserProfileInCms = exports.AppUserProfile = undefined;

var _joi = require("joi");

var Joi = _interopRequireWildcard(_joi);

var _types = require("./types");

var types = _interopRequireWildcard(_types);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// AppUserProfile for the app
// --------------------------
var AppUserProfile = exports.AppUserProfile = Joi.object().required().keys({
    uid: types.uidv4.required(),
    name: Joi.string().required().allow(null).description("Name of the user (first + lastname)"),
    email: Joi.string().required(),
    isActive: Joi.boolean(),
    companyName: Joi.string().required(),
    // type: Joi.string().optional().allow("user", "manager"),
    canShare: Joi.boolean().required(),
    UserId: Joi.number(),
    scope: Joi.array().items(Joi.string()).required().description("The scope (roles & permissions) of this user.")
}).label("AppUserProfile").description("Provides all profile information about an AppUser");
// AppUserProfile for the CMS
// --------------------------
var AppUserProfileInCms = exports.AppUserProfileInCms = Joi.object().required().keys({
    id: Joi.number().required().description("Internal database id of the user"),
    uid: types.uidv4.required(),
    name: Joi.string().required().allow(null).description("Name of the user (first + lastname)"),
    email: Joi.string().required(),
    isActive: Joi.boolean().required(),
    canShare: Joi.boolean().required(),
    UserId: Joi.number(),
    scope: Joi.array().items(Joi.string()).required().description("The scope (roles & permissions) of this user.")
}).label("AppUserProfileInCms");
var AppUserProfileInCmsPost = exports.AppUserProfileInCmsPost = Joi.object().required().keys({
    name: Joi.string().required().allow(null).description("Name of the user (first + lastname)"),
    email: Joi.string().required(),
    canShare: Joi.boolean().required(),
    UserId: Joi.number(),
    type: Joi.string().optional().allow("user", "manager")
}).label("AppUserProfileInCmsPost");
var AppUserProfileInCmsPatch = exports.AppUserProfileInCmsPatch = Joi.object().required().keys({
    name: Joi.string().required().allow(null).description("Name of the user (first + lastname)"),
    isActive: Joi.boolean().required(),
    canShare: Joi.boolean().required(),
    UserId: Joi.number(),
    type: Joi.string().optional().allow("user", "manager")
}).label("AppUserProfileInCmsPatch");


/*****************
 ** WEBPACK FOOTER
 ** ../backend/src/shared/schemas/AppUserProfile.ts
 ** module id = 1263
 ** module chunks = 0
 **/